import React from 'react';
import rehypeRaw from 'rehype-raw';
import LandingComponentButtonForm from '../LandingComponentButtonForm';
import MDEditor from '@uiw/react-md-editor';
import { CommonHash } from 'app/types';
import {
  TITLESIZEOPTIONS,
  TEXTCOLOROPTIONS,
  ALIGNMENTOPTIONS,
  BADGECOLOROPTIONS,
  DESCRIPTIONSIZEOPTIONS,
  TITLETYPEOPTIONS,
} from 'common/constants';

interface TitleFormField {
  label: string;
  fieldName: string;
  type: string;
  options?: string[];
  placeholder?: string;
  limit?: number;
  required?: boolean;
}
const TitleFormFields: TitleFormField[] = [
  { label: 'Text Alignment', fieldName: 'alignment', type: 'select', options: ALIGNMENTOPTIONS },
  {
    label: 'Section Title',
    fieldName: 'section_title',
    type: 'input',
    placeholder: 'Title of the section',
  },
  {
    label: 'Section Title Color',
    fieldName: 'section_title_color',
    type: 'select',
    options: TEXTCOLOROPTIONS,
  },
  { label: 'Badge Text', fieldName: 'badge', type: 'input', placeholder: 'Promotional text' },
  { label: 'Badge Color', fieldName: 'badge_color', type: 'select', options: BADGECOLOROPTIONS },
  { label: 'Title', fieldName: 'title', type: 'input', placeholder: 'Title text' },
  { label: 'Title Type', fieldName: 'title_type', type: 'select', options: TITLETYPEOPTIONS },
  { label: 'Title Size', fieldName: 'title_size', type: 'select', options: TITLESIZEOPTIONS },
  { label: 'Title Color', fieldName: 'title_color', type: 'select', options: TEXTCOLOROPTIONS },
  { label: 'Description', fieldName: 'description', type: 'markdown' },
  {
    label: 'Description Size',
    fieldName: 'description_size',
    type: 'select',
    options: DESCRIPTIONSIZEOPTIONS,
  },
  {
    label: 'Description Color',
    fieldName: 'description_color',
    type: 'select',
    options: TEXTCOLOROPTIONS,
  },
  { label: 'Buttons', fieldName: 'buttons', type: 'buttons', limit: 3 },
];

interface ComponentFormProps {
  landing_cmp: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  index: number;
}

const TitleComponentForm = ({
  landing_cmp,
  handleChange,
  index,
}: ComponentFormProps): React.ReactElement => {
  return (
    <section className="py-3">
      {TitleFormFields.map((field, i) => (
        <div className="form-group my-3" key={i}>
          <label
            htmlFor={`landing_components[${index}].config['${field.fieldName}']`}
            className="fs-6 mb-2"
          >
            {field.label}
          </label>
          {(() => {
            switch (field.type) {
              case 'input':
                return (
                  <input
                    key={i}
                    className="form-control"
                    name={`landing_components[${index}].config['${field.fieldName}']`}
                    placeholder={field.placeholder}
                    onChange={handleChange}
                    required={field.required ? field.required : false}
                    value={landing_cmp.config ? landing_cmp.config[field.fieldName] : ''}
                  />
                );
              case 'select':
                return (
                  <select
                    key={i}
                    className="form-select"
                    name={`landing_components[${index}].config['${field.fieldName}']`}
                    onChange={handleChange}
                    required={field.required ? field.required : false}
                    value={
                      landing_cmp.config ? landing_cmp.config[field.fieldName] : field.options?.[0]
                    }
                  >
                    {field.options?.map((opt, e) => {
                      return (
                        <option key={e} className="text-capitalize" value={opt}>
                          {opt}
                        </option>
                      );
                    })}
                  </select>
                );
              case 'markdown':
                return (
                  <MDEditor
                    key={i}
                    className="w-100"
                    value={landing_cmp.config ? landing_cmp.config[field.fieldName] : ''}
                    onChange={(md) =>
                      handleChange({
                        target: {
                          name: `landing_components[${index}].config['${field.fieldName}']`,
                          value: md,
                        },
                      })
                    }
                    previewOptions={{
                      rehypePlugins: [[rehypeRaw]],
                    }}
                  />
                );
              case 'buttons':
                return (
                  <LandingComponentButtonForm
                    name={`landing_components[${index}].landing_component_buttons`}
                    landing_component={landing_cmp}
                    handleChange={handleChange}
                    limit={field.limit ? field.limit : 3}
                  />
                );
            }
          })()}
        </div>
      ))}
    </section>
  );
};

export { TitleFormFields, TitleComponentForm };
